// extracted by mini-css-extract-plugin
export default {"popularTours":"PopularTours_popularTours__o+wIK"};